<template>
        <div v-for="(field, key) in fields" :key="field.id" style="margin-bottom:4px;" class="flex border rounded border-gray-200 p-4 flex-col">
            <div class="field w-full px-3 mb-3">
            <JetLabel
                class="w-full"
                for="nama_pegawai"
                value="Nama Pegawai"
            />
            <Input
                id="nama_pegawai"
                v-model="field.nama_pegawai"
                type="text"
                placeholder="Nama Pegawai"
                class="mt-1 block w-full"
            />
            </div>
            <div class="field w-full px-3 mb-3">
            <JetLabel
                class="w-full"
                for="nik_pegawai"
                value="NIK Pegawai"
            />
            <Input
                id="nik_pegawai"
                v-model="field.nik_pegawai"
                type="text"
                placeholder="NIK Pegawai"
                class="mt-1 block w-full"
            />
            </div>
            <div class="field w-full px-3 mb-3">
            <JetLabel
                class="w-full"
                for="pendidikan_pegawai"
                value="Pendidikan Pegawai"
            />
            <Input
                id="pendidikan_pegawai"
                v-model="field.pendidikan_pegawai"
                type="text"
                placeholder="Pendidikan Pegawai"
                class="mt-1 block w-full"
            />
            </div>
            <div class="field w-full px-3 mb-3">
            <JetLabel
                class="w-full"
                for="keahlian_pegawai"
                value="Keahlian Pegawai"
            />
            <Input
                id="keahlian_pegawai"
                v-model="field.keahlian_pegawai"
                type="text"
                placeholder="Keahlian Pegawai"
                class="mt-1 block w-full"
            />
            </div>
            <div class="field w-full px-3 mb-3">
                <JetLabel
                    class="w-full"
                    for="file_pegawai"
                    value="File Pegawai ( KTP,IJAZAH,SERTIFIKASI KEAHLIAN ) .pdf"
                />
                <Input
                    id="file_pegawai"
                    @change="onChangeFile(key,$event)"
                    type="file"
                    class="mt-1 block w-full"
                    accept="application/pdf"
                />
            </div>
            <div class="field w-full px-3 mb-3">
                <Input
                    id="nama_file"
                    type="text"
                    readonly="true"
                    v-model="field.nama_file"
                    class="mt-1 block w-full"
                    accept="application/pdf"
                />
            </div>

            <div class="field w-full px-3" >
                    <ButtonDelete type="button" @click="RemoveField(key)" ><i class="fas fa-times-circle"></i></ButtonDelete>
            </div>
        </div>
        <div class="field w-full px-3 mb-3 mt-5" >
            <ButtonAdd type="button" @click="AddField" label="Tambah" ><i class="fas fa-plus-circle"></i> Tambah</ButtonAdd>
        </div>
</template>

<script>
    import { defineComponent } from 'vue'
    import Input from "@/Components/Input.vue";
    import ButtonAdd from "@/Components/ButtonAdd.vue";
    import ButtonDelete from "@/Components/ButtonDelete.vue";
    import JetLabel from "@/Jetstream/Label.vue";

    export default defineComponent({
        components: {
            Input,
            ButtonAdd,
            ButtonDelete,
            JetLabel
        },
        name: 'InputRepeaterPegawai',
        props: {
            modelValue: {
                type: Object,
                default: () => []
            }
        },
        data() {
            return {
                fields: {
                    nama_pegawai: '',
                    nik_pegawai: '',
                    pendidikan_pegawai: '',
                    keahlian_pegawai: '',
                    file_pegawai: '',
                    nama_file: ''
                }
            }
        },
        computed: {
            model: {
                get: function (){
                    return this.fields;
                },
                set: function (value) {
                    this.fields = value;
                }
            }
        },
        mounted() {
            // this.fields = Vue.util.extend([{}], this.modelValue);
            // fire.$on('reset', this.resetField);
            // this.$emit('modelValue', this.fields);
            this.fields = this.modelValue;
            // console.log(this.modelValue);
        },
        methods: {
            AddField() {
                this.$emit('modelValue', this.fields);
                this.fields.push({file_pegawai: ''});
                // this.fields = this.modelValue;
                // console.log(this.fields);
            },
            RemoveField(key) {
                this.fields.splice(key, 1);
            },
            resetField() {
                this.fields = [{}];
            },
            onChangeFile(item,event) {
                let file = event.target.files[0];
                console.log(item);
                // memasukan file ke object fields
                console.log(file);
                console.log(this.fields[0].file_pegawai);
                this.fields[item].file_pegawai = file;
                //emit  ke parent
                this.$emit('modelValue', this.fields);
                console.log(this.fields);
                //masukan nama file ke field nama_file
                this.fields[item].nama_file = file.name;
            }

        },
    });
</script>
